module.exports = __webpack_public_path__ + "img/isa2.548b0538.png";